module.exports = __webpack_public_path__ + "img/sup_faq_banner.cd881ee4.jpg";